import { render, staticRenderFns } from "./KPIProgressBar.vue?vue&type=template&id=4a07b230&scoped=true&"
import script from "./KPIProgressBar.vue?vue&type=script&lang=js&"
export * from "./KPIProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./KPIProgressBar.vue?vue&type=style&index=0&id=4a07b230&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07b230",
  null
  
)

export default component.exports